import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "vehicle" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.5 17.5H2.83333C2.37333 17.5 2 17.1267 2 16.6667V15H14.5V7.5H18.3892C19.32 7.5 19.7225 7.98 20.0025 8.4225C20.4975 9.20583 21.2825 10.4492 21.76 11.2375C21.9167 11.4975 22 11.7958 22 12.1V15.8333C22 16.7675 21.3933 17.5 20.3333 17.5H19.5C19.5 18.88 18.38 20 17 20C15.62 20 14.5 18.88 14.5 17.5H9.5C9.5 18.88 8.38 20 7 20C5.62 20 4.5 18.88 4.5 17.5ZM6.99999 16.5C7.55166 16.5 7.99999 16.9483 7.99999 17.5C7.99999 18.0517 7.55166 18.5 6.99999 18.5C6.44832 18.5 5.99999 18.0517 5.99999 17.5C5.99999 16.9483 6.44832 16.5 6.99999 16.5ZM17 16.5C17.5517 16.5 18 16.9483 18 17.5C18 18.0517 17.5517 18.5 17 18.5C16.4483 18.5 16 18.0517 16 17.5C16 16.9483 16.4483 16.5 17 16.5ZM13.6667 14.1667H2V5.83333C2 5.37333 2.37333 5 2.83333 5H12.8333C13.2933 5 13.6667 5.37333 13.6667 5.83333V14.1667ZM16.1667 9.16667V11.6667H20.0958L18.9067 9.58667C18.7583 9.32667 18.4825 9.16667 18.1833 9.16667H16.1667Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }